import React, { FC, useState, useEffect, Suspense } from 'react'
import Loading from './Loading'

const PageSuspense: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [ _, setRenderCounter ] = useState(1)
  useEffect(() => {
    setTimeout(() => setRenderCounter(new Date().getTime()), 1000)
  }, [])
  return (
    <Suspense fallback={<Loading />}>
      { children }
    </Suspense>
  )
}

export default PageSuspense